import React from 'react';

import { Snackbar as MuiSnackbar } from '@mui/material';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';

interface SnackbarProps {
	severity: AlertColor;
	message: string;
	openSnackbar: boolean;
	handleClose: (
		event?: React.SyntheticEvent | Event,
		reason?: string,
	) => void;
	hideDuration?: number;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
	props,
	ref,
) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Snackbar: React.FC<SnackbarProps> = ({
	severity,
	message,
	openSnackbar,
	handleClose,
	hideDuration = 3000,
}) => {
	// TODO: Make The state of severity and message compound
	return (
		<MuiSnackbar
			open={openSnackbar}
			autoHideDuration={hideDuration}
			onClose={handleClose}
		>
			<Alert
				onClose={handleClose}
				severity={severity}
				sx={{ width: '100%' }}
			>
				{message}
			</Alert>
		</MuiSnackbar>
	);
};
export default Snackbar;
